import React, { useState } from 'react';
import Modal from './Modal';
import { DynamicForm } from '../form/DynamicForm';
import { Toast } from '../ui';
import { useTheme } from '../../contexts/ThemeContext';
import { LockOutlined } from '@ant-design/icons';

const ChangePasswordModal = ({ open, onCancel, onSave, userId, loading = false }) => {
  const [form, setForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const { theme } = useTheme();

  const handleSubmit = async (values) => {
    // Todas as validações são feitas automaticamente pelo DynamicForm
    // incluindo: senhas coincidem, nova senha robusta, campos obrigatórios
    
    try {
      // Preparar dados para envio
      const passwordData = {
        userId: userId,
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      };

      // Chamar função de callback passada pelo componente pai
      if (onSave) {
        await onSave(passwordData);
      }
      
      // Limpar formulário após sucesso
      handleClose();
    } catch (error) {
      // O tratamento de erro será feito no componente pai
      console.error('Erro no modal de alteração de senha:', error);
    }
  };

  const handleClose = () => {
    setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    onCancel();
  };

  return (
    <Modal
      title="Alterar Senha"
      open={open}
      onCancel={handleClose}
      footer={null}
      width={500}
      style={{ borderRadius: '12px' }}
      
    >
      <DynamicForm
        formConfig={[{
          columns: 1,
          questions: [
            { 
              id: 'currentPassword', 
              label: 'Senha Atual', 
              type: 'password', 
              required: true, 
              prefixIcon: <LockOutlined />,
              placeholder: 'Digite sua senha atual',
              // Senha atual não precisa de validação robusta nem indicador
              requireUppercase: false,
              requireLowercase: false,
              requireNumbers: false,
              requireSpecialChars: false,
              minLength: 1,
              showStrengthIndicator: false
            },
            { 
              id: 'newPassword', 
              label: 'Nova Senha', 
              type: 'password', 
              required: true, 
              prefixIcon: <LockOutlined />,
              placeholder: 'Digite a nova senha',
              minLength: 8,
              requireUppercase: true,
              requireLowercase: true,
              requireNumbers: true,
              requireSpecialChars: true,
              showStrengthIndicator: true
            },
            { 
              id: 'confirmPassword', 
              label: 'Confirmar Nova Senha', 
              type: 'confirmPassword', 
              required: true, 
              prefixIcon: <LockOutlined />,
              placeholder: 'Confirme a nova senha',
              compareField: 'newPassword'
            },
          ]
        }]}
        values={form}
        setValues={setForm}
        submitText="Alterar Senha"
        onSubmit={handleSubmit}
        inputPadding="10px 12px"
        onClose={handleClose}
        loading={loading}
        submitButtonStyle={{ backgroundColor: theme.primary, color: '#fff', border: 'none' }}
        cancelButtonStyle={{
          borderColor: theme.borderColor,
          color: theme.textSecondary,
          borderRadius: '8px',
          height: 'auto',
        }}
      />
    </Modal>
  );
};

export default ChangePasswordModal; 